module.exports = __webpack_public_path__ + "img/阳台面宽.453c2b5b.webp";